import { Injectable } from '@angular/core';

import { QueryEntity } from '@datorama/akita';

import { ServiceState } from './service.state';
import { ServiceStore } from './service.store';

@Injectable({providedIn: 'root'})
export class ServiceQuery extends QueryEntity<ServiceState> {
  constructor(protected store: ServiceStore) {
    super(store);
  }
}
